const cloudy = [
'09-22-06_0732.JPG',
'IMG_0001.JPG',
'IMG_0010.JPG',
'IMG_0153.JPG',
'IMG_0270.JPG',
'IMG_0648.JPG',
'IMG_0821.JPG',
'IMG_0913.JPG',
'IMG_0914.JPG',
'IMG_0917.JPG',
'IMG_1051.JPG',
'IMG_1065.JPG',
'IMG_1473.JPG',
'IMG_1539.JPG',
'IMG_1785.JPG',
'IMG_1807.JPG',
'IMG_1841.JPG',
'IMG_2092.JPG',
'IMG_2115.JPG',
'IMG_2116.JPG',
'IMG_2149.JPG',
'IMG_2202.JPG',
'IMG_2209.JPG',
'IMG_2235.JPG',
'IMG_2244.JPG',
'IMG_2245.JPG',
'IMG_2289.JPG',
'IMG_2349.JPG',
'IMG_2350.JPG',
'IMG_2514.JPG',
'IMG_2539.JPG',
'IMG_2546.JPG',
'IMG_2549.JPG',
'IMG_2559.JPG',
'IMG_2567.JPG',
'IMG_2571.JPG',
'IMG_2575.JPG',
'IMG_2598.JPG',
'IMG_2646.JPG',
'IMG_2651.JPG',
'IMG_2652.JPG',
'IMG_2659.JPG',
'IMG_3231.JPG',
'IMG_3271.JPG',
'IMG_3461.JPG',
'IMG_3523.JPG',
'IMG_3528.JPG',
'IMG_3596.JPG',
'IMG_3618.JPG',
'IMG_3655.JPG',
'IMG_3781.JPG',
'IMG_4285.JPG',
'IMG_4461.JPG',
'REBELXS_IMG_0302.JPG',
'REBELXS_IMG_0359.JPG',
'REBELXS_IMG_0361.JPG',
'REBELXS_IMG_0963.JPG',
'REBELXS_IMG_1088.JPG',
'REBELXS_IMG_1236.JPG',
'REBELXS_IMG_1648.JPG',
'REBELXS_IMG_2097.JPG',
'REBELXS_IMG_2386.JPG',
'REBELXS_IMG_2634.JPG',
'REBELXS_IMG_2737.JPG',
'REBELXS_IMG_3068.JPG',
'REBELXS_IMG_3100.JPG',
'REBELXS_IMG_3197.JPG',
'REBELXS_IMG_3221.JPG',
'REBELXS_IMG_3452.JPG',
'REBELXS_IMG_3462.JPG',
'REBELXS_IMG_3482.JPG',
'REBELXS_IMG_3546.JPG',
'STC_2173.JPG',
'IPHONE2G_IMG_0056.JPG',
'IPHONE2G_IMG_0109.JPG',
'IPHONE2G_IMG_0185.JPG',
'IPHONE2G_IMG_0347.JPG'];

export default cloudy;